"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastPortal = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const react_transition_group_1 = require("react-transition-group");
const ToastContext_1 = require("context/ToastContext");
const useToastAutoClose_1 = __importDefault(require("hooks/useToastAutoClose"));
require("./ToastPortal.scss");
const ToastComponent_1 = __importDefault(require("./component/ToastComponent"));
const ToastPortal = ({ autoClose = true, autoCloseTime = 5000 }) => {
    const { toasts, portalId, removeToast, loaded, newToast } = (0, ToastContext_1.useToastContext)();
    (0, useToastAutoClose_1.default)({
        removeToast,
        autoClose,
        autoCloseTime,
        newToast
    });
    const targetElement = document.getElementById(portalId);
    return loaded && targetElement ? (react_dom_1.default.createPortal(react_1.default.createElement(react_transition_group_1.TransitionGroup, null, toasts.map((toast) => (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: toast?.id, timeout: 500, classNames: "toast-transition" },
        react_1.default.createElement(ToastComponent_1.default, { msg: toast?.msg, title: toast?.title, type: toast?.type, onClose: () => toast?.id && removeToast(toast?.id), useIcon: toast.useIcon, progressPercentage: toast?.progressPercentage }))))), targetElement)) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.ToastPortal = ToastPortal;
